export default __webpack_public_path__ + "static/media/east-elevation.a78782de.png";